import { connect } from 'react-redux';

import { HeaderDefault } from './index';
import { IAppState } from '../../../../common/state';

export function mapStateToProps(state: IAppState) {
  return {
    seo: state.results.seo,
    breadcrumbs: state.breadcrumbs,
  };
}

export const HeaderDefaultContainer = connect(mapStateToProps)(HeaderDefault);
